import React from 'react';

function Footer() {
  return (
    <footer style={footerStyle}>
      <p>&copy; 2024 Soohyun Jo. All rights reserved.</p>
    </footer>
  );
}

const footerStyle = {
  position: 'fixed',
  bottom: 0,
  width: '100%',
  padding: '10px',
  backgroundColor: 'rgba(255,255,255,0.9)',
  textAlign: 'center',
  fontSize: '0.8rem',
};

export default Footer; 